var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Uh-Oh!")]),_c('h3',[_vm._v("It looks you're experiencing some network issues, please click the back button and try again.")]),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Or go back to the kit list")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }